export default __webpack_public_path__ + "static/media/card-2.3159a3bb.jpeg";